import {useContext} from "react";
import AuthContext from "../../context/AuthContext";

const formatDateTime = (value) => {
    if (!value) {
        return "-";
    }

    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) {
        return value;
    }

    return parsed.toLocaleString();
};

const formatBoolean = (value) => (value ? "Yes" : "No");

function BasicInformationTab() {
    const {user, isUserLoading} = useContext(AuthContext);

    if (isUserLoading) {
        return (
            <div className="text-center py-4">
                <p className="text-muted mb-0">Loading basic information...</p>
            </div>
        );
    }

    if (!user) {
        return (
            <div className="text-center py-4">
                <p className="text-muted mb-0">Basic information is not available.</p>
            </div>
        );
    }

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="table-responsive">
                    <table className="table table-centered table-borderless mb-0">
                        <tbody>
                        <tr>
                            <td style={{width: 220}}>Username</td>
                            <td>{user.username || "-"}</td>
                        </tr>
                        <tr>
                            <td>Email</td>
                            <td>{user.email || "-"}</td>
                        </tr>
                        <tr>
                            <td>First Name</td>
                            <td>{user.first_name || "-"}</td>
                        </tr>
                        <tr>
                            <td>Last Name</td>
                            <td>{user.last_name || "-"}</td>
                        </tr>
                        <tr>
                            <td>Phone</td>
                            <td>{user.phone || "-"}</td>
                        </tr>
                        <tr>
                            <td>Date Joined</td>
                            <td>{formatDateTime(user.date_joined)}</td>
                        </tr>
                        <tr>
                            <td>Last Login</td>
                            <td>{formatDateTime(user.last_login)}</td>
                        </tr>
                        <tr>
                            <td>KYC Status</td>
                            <td>{user.kyc_status || "-"}</td>
                        </tr>
                        <tr>
                            <td>Email Verified</td>
                            <td>{formatBoolean(user.is_email_verified)}</td>
                        </tr>
                        <tr>
                            <td>Phone Verified</td>
                            <td>{formatBoolean(user.is_phone_verified)}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default BasicInformationTab;
